import React, { useState } from 'react';
import Locales from 'locales';
import { renderCGUContent } from 'helpers';
import { LegalAccordionPage, LegalAccordionRow } from 'components/shared/LegalAccordionPage';

const renderSections = (sections, prefix) =>
  Object.keys(sections).map((key) => {
    const section = sections[key];

    return (
      <div key={`${prefix}-${key}`}>
        {section.title && <h3 className="mb-2 font-semibold text-gray-900">{section.title}</h3>}
        {renderCGUContent(section.content, `${prefix}-${key}`)}
      </div>
    );
  });

const LegalMention = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleBlock = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <LegalAccordionPage title={Locales.legal.title} description={Locales.legal.description}>
      {Locales.legal.articles.map((article) => (
        <LegalAccordionRow
          key={article.id}
          id={`legal-article-${article.id}`}
          title={article.title}
          isOpen={openIndex === article.id}
          onToggle={() => toggleBlock(article.id)}
        >
          {article.preamble && <p className="mb-3">{article.preamble}</p>}
          {renderCGUContent(article.content, `article-${article.id}`)}
        </LegalAccordionRow>
      ))}

      <LegalAccordionRow
        id={`legal-tos-${Locales.legal.tos.id}`}
        title={Locales.legal.tos.title}
        isOpen={openIndex === Locales.legal.tos.id}
        onToggle={() => toggleBlock(Locales.legal.tos.id)}
      >
        {renderSections(Locales.legal.tos.sections, 'tos')}
      </LegalAccordionRow>

      <LegalAccordionRow
        id={`legal-conf-${Locales.legal.confidentiality.id}`}
        title={Locales.legal.confidentiality.title}
        isOpen={openIndex === Locales.legal.confidentiality.id}
        onToggle={() => toggleBlock(Locales.legal.confidentiality.id)}
      >
        {renderSections(Locales.legal.confidentiality.sections, 'conf')}
      </LegalAccordionRow>
    </LegalAccordionPage>
  );
};

export default LegalMention;
